module.exports = __webpack_public_path__ + "static/fontawesome-webfont.c8ddf1e5.woff";


//////////////////
// WEBPACK FOOTER
// ./src/css/assets/fonts/fontawesome-webfont.woff?v=4.6.3
// module id = ./src/css/assets/fonts/fontawesome-webfont.woff?v=4.6.3
// module chunks = 7489246917808536000